import React from "react";
import type { StickerWidget } from "../types";
import style from "./stickerResult.module.css";

export function StickerResult({ widgetData }: { widgetData: StickerWidget }) {
    return (
        <div className={style.stickerWrapper} style={{ background: widgetData.color }}>
            <div className={style.stickerText}>{widgetData.text}</div>
        </div>
    );
}
